import { CatalogSectionItemClassification } from '../../../modules/catalogs/products/interfaces/catalogProductList.types';
import { MediaFormatEnum } from '../../../modules/general-settings/enums/mediaFormat.enum';
import { ESColorClassification, ESProductTag } from '../../../modules/products/ProductTypes';
import { ColorClassification, Tag } from '../../../modules/products/product.types.v2';
import { SelloutTotalsProductColor } from '../../../services/modules/product-color-sellout/product-color-sellout.types';

interface ProductTagsFactoryParams {
  customTags?: (ColorClassification | Tag | CatalogSectionItemClassification)[];
  isSuggestedProduct?: boolean;
  selloutMetrics?: SelloutTotalsProductColor | undefined;
  mediaFormat: MediaFormatEnum;
}

export interface ProductTag {
  type: 'colorClassification' | 'sellout' | 'suggested';
  props?: {
    quantity?: number;
    tags?: (ESColorClassification | ESProductTag | CatalogSectionItemClassification)[];
  };
}

type ProductTagGroup = {
  topTags: ProductTag[] | null;
  bottomTags: ProductTag[] | null;
};

const useGetProductTagGroups = ({
  customTags,
  mediaFormat,
  isSuggestedProduct,
  selloutMetrics,
}: ProductTagsFactoryParams): ProductTagGroup => {
  const dynamicTag: ProductTag | null =
    customTags && customTags.length > 0
      ? {
          type: 'colorClassification',
          props: { tags: [...customTags] },
        }
      : null;

  const suggestedTag: ProductTag | null = isSuggestedProduct ? { type: 'suggested' } : null;

  const selloutTag: ProductTag | null = selloutMetrics
    ? {
        type: 'sellout',
        props: { quantity: selloutMetrics.totalQuantitySold },
      }
    : null;

  const topTags =
    mediaFormat === MediaFormatEnum.SQUARE
      ? [dynamicTag].filter((tag) => !!tag)
      : [suggestedTag, selloutTag].filter((tag) => !!tag);

  const bottomTags =
    mediaFormat === MediaFormatEnum.SQUARE
      ? [suggestedTag, selloutTag].filter((tag) => !!tag)
      : [dynamicTag].filter((tag) => !!tag);

  return {
    topTags,
    bottomTags,
  };
};

export default useGetProductTagGroups;
